export default __webpack_public_path__ + "static/media/SulfateFree(2).86cd86b2.svg";